module.exports = __webpack_public_path__ + "img/Fattoush Salad with Cashew Nuts.cda5afb6.png";